import * as React from 'react'

import { cn } from '@/common/lib/utils'

interface InputProps extends React.ComponentProps<'input'> {
	onNumberChange?: (value: number | null) => void
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
	({ className, type, onNumberChange, onChange, ...props }, ref) => {
		const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
			if (type === 'number' && onNumberChange) {
				const value = e.target.value
				if (value === '' || value === null || value === undefined) {
					onNumberChange(null)
				} else {
					const numericValue = Number(value)
					onNumberChange(isNaN(numericValue) ? null : numericValue)
				}
			} else if (onChange) {
				onChange(e)
			}
		}

		return (
			<input
				type={type}
				className={cn(
					// min-w-0: an <input> carries an intrinsic width (~20 chars); as a
					// grid/flex item that becomes its automatic minimum size, so inside a
					// fixed-width panel (e.g. a dialog) it pushes past the panel edge
					// instead of shrinking.
					'flex h-9 w-full min-w-0 rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
					className,
				)}
				onWheel={(e) => {
					if (e.target instanceof HTMLElement) {
						e.target.blur()
					}
				}}
				onChange={handleChange}
				ref={ref}
				{...props}
			/>
		)
	},
)
Input.displayName = 'Input'

export { Input }
